// extracted by mini-css-extract-plugin
export var divider = "_vt-0";